import styles from './addskudisclaimer.module.scss';

type AddSkuPageDisclaimerProps = {
  disclaimer?: string;
};

export default function AddSkuPageDisclaimer({ disclaimer = '' }: AddSkuPageDisclaimerProps) {
  return disclaimer ? (
    <div className={styles.skuDisclaimer}>
      <p>{disclaimer}</p>
    </div>
  ) : null;
}
